import React from "react";
import Layout from "@/components/Layout";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

const CookiePolicy = () => {
  return (
    <>
      <SEO title="Cookie Policy - Send a Sloth" />
      <Layout>
        <h1 className="text-center text-[#294870] text-4xl lg:text-5xl font-bold">
          Cookie Policy
        </h1>
        <div className="flex items-center justify-center py-8 w-full h-auto">
          <div className="max-w-3xl text-lg text-gray-700 leading-relaxed space-y-6">
            <p>
              This Cookie Policy explains how <strong>Send a Sloth</strong> uses
              cookies and similar technologies to recognize you when you visit
              our website,{" "}
              <a
                href="https://sloths.co.uk"
                className="text-blue-500 underline"
              >
                sloths.co.uk
              </a>
              . It explains what these technologies are and why we use them, as
              well as your rights to control their use.
            </p>

            <h2 className="text-2xl font-semibold text-[#294870]">
              What Are Cookies?
            </h2>
            <p>
              Cookies are small text files that are stored on your device when
              you visit a website. They help the website remember information
              about your visit, such as your preferred language and other
              settings. This makes your next visit easier and the site more
              useful to you.
            </p>

            <h2 className="text-2xl font-semibold text-[#294870]">
              Types of Cookies We Use
            </h2>
            <ul className="list-disc list-inside space-y-2">
              <li>
                <strong>Essential Cookies:</strong> These cookies are necessary
                for the website to function and cannot be switched off in our
                systems. They are usually set only in response to actions made
                by you, such as setting your privacy preferences or filling out
                forms.
              </li>
              <li>
                <strong>Performance Cookies:</strong> These cookies collect
                information about how visitors use a website, such as which
                pages are visited most often. This helps us improve the
                performance of our site.
              </li>
              <li>
                <strong>Functional Cookies:</strong> These cookies enable the
                website to provide enhanced functionality and personalization.
                They may be set by us or by third-party providers whose services
                we have added to our pages.
              </li>
              <li>
                <strong>Targeting Cookies:</strong> These cookies may be set
                through our site by our advertising partners. They may be used
                to build a profile of your interests and show you relevant ads
                on other sites.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-[#294870]">
              How We Use Cookies
            </h2>
            <p>We use cookies to enhance your browsing experience by:</p>
            <ul className="list-disc list-inside space-y-2">
              <li>Remembering your preferences and settings.</li>
              <li>Improving website functionality and performance.</li>
              <li>Providing personalized content and recommendations.</li>
              <li>
                Analyzing website traffic to understand user behavior and
                improve our site.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-[#294870]">
              Your Choices
            </h2>
            <p>
              You have the right to decide whether to accept or reject cookies.
              You can set your browser to block or alert you about these
              cookies, but some parts of the site may not work as intended if
              you do so. To learn more about how to manage your cookie settings
              in your browser, please visit your browser's help menu.
            </p>

            <h2 className="text-2xl font-semibold text-[#294870]">
              Changes to This Policy
            </h2>
            <p>
              We may update this Cookie Policy from time to time to reflect
              changes to the cookies we use or for other operational, legal, or
              regulatory reasons. Please revisit this Cookie Policy regularly to
              stay informed about our use of cookies and related technologies.
            </p>

            <h2 className="text-2xl font-semibold text-[#294870]">
              Contact Us
            </h2>
            <p>
              If you have any questions about this Cookie Policy, please contact
              us at:
            </p>
            <address className="not-italic space-y-1">
              <p>Send a Sloth</p>
              <p>Mango Drum Ltd.</p>
              <p>86-90 Paul Street, London, England, EC2A 4NE</p>
              <p>
                Email:{" "}
                <a
                  href="mailto:info@sloths.co.uk"
                  className="text-blue-500 underline"
                >
                  info@sloths.co.uk or amazon@sloths.co.uk
                </a>
              </p>
            </address>
          </div>
        </div>
      </Layout>
      <Footer />
    </>
  );
};

export default CookiePolicy;
